import API from '../../../../../services/api';

export const DIRECCIONES_API = {
    new: async (direccion) => {
        return API.post('/direcciones', direccion).then(res => res.data);
    },
    update: async (direccion) => {
        return API.put('/direcciones/' + direccion.id, direccion).then(res => res.data);
    }
}